module.exports = __webpack_public_path__ + "img/ember_spirit.77d2dbf7.png";